<template>
    <b-modal
        id="checkoutModal"
        v-model="showModal"
        size="xxl"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="dark"
        body-bg-variant="dark"
        hide-footer
        hide-header
        centered
        @hide="$emit('hideTempModal');onHide($event)"
    >

        <div class="modal-body custom-modal-class">
            <div class="close-button" @click="$emit('hideTempModal')">X</div>
            <div class="full-width">
                <div class="modal-header align-left">
                    <h2 class="m-0">Compania este neeligibilă</h2>
                </div>
                <p style="font-size: 15px;" class="mb-3"><strong>Atenționare! Din informațiile noastre analiza returnează statutul: <span class="red-text">COMPANIE NEELIGIBILĂ</span></strong></p>
                <p>Există posibilitatea (în puține cazuri) ca analiza să nu fie corectă, motivele fiind variate (nu sunt importate corect informațiile financiare, informații lipsă etc).</p>
                <p>Dacă ai verificat personal eligibilitatea companiei și ai concluzionat că aceasta este eligibilă, vei continua către scrierea proiectului. Îți mulțumim pentru înțelegere și pentru interesul acordat aplicațiilor noastre.</p>

                <validation-observer #default="{ invalid }" ref="observer">
                    <span class="display-none">{{ invalid }}</span>
                    <b-form class="mb-3 mt-2 custom-inner-wrapper">
                        <div class="flex justify-between items-center">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                name="cifra de afaceri 2019"
                                class="form-wrapper"

                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-sm="3"
                                    label-cols-lg="3"
                                    class="custom-field-class"
                                    content-cols-sm
                                    content-cols-lg="9"
                                    label="Cifra de afaceri 2019"
                                >
                                    <b-form-input
                                        id="ca2019"
                                        v-model="form.ca2019"
                                        type="number"
                                        name="ca2019"
                                        :state="errors.length || !caDifference > 0 || form.ca2019 < 49460 ? false : null"
                                        @input="calculateCA"
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                    <small v-if="!caDifference" class="text-danger">Nu există scădere a cifrei de afaceri</small>
                                    <small v-else-if="form.ca2019 < 49460" class="text-danger">Cifra de afaceri este mai mică de 49.460 lei</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                name="cifra de afaceri 2020"
                                class="form-wrapper"

                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-sm="3"
                                    class="custom-field-class"
                                    label-cols-lg="3"
                                    content-cols-sm
                                    content-cols-lg="9"
                                    label="Cifra de afaceri 2020"
                                >
                                    <b-form-input
                                        id="ca2020"
                                        v-model="form.ca2020"
                                        type="number"
                                        name="ca2020"
                                        :state="errors.length || !caDifference > 0 ? false : null"
                                        @input="calculateCA()"
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                    <small v-if="!caDifference" class="text-danger">Nu există scădere a cifrei de afaceri</small>
                                </b-form-group>
                            </validation-provider>
                        </div>
                        <div class="flex justify-between items-center mt-2">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                name="anul înființării"
                                class="form-wrapper"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-sm="3"
                                    class="custom-field-class"
                                    label-cols-lg="3"
                                    content-cols-sm
                                    content-cols-lg="9"
                                    label="Anul înființării"
                                >
                                    <b-form-input
                                        id="date"
                                        v-model="form.date"
                                        type="number"
                                        name="date"
                                        :state="errors.length > 0 || form.date > 2018 ? false : null"
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                    <small v-if="form.date > 2018" class="text-danger mt-1">Firma este înființată după 2018</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="form-wrapper"
                                name="profit 2019"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    class="custom-field-class"
                                    label-cols-sm="3"
                                    label-cols-lg="3"
                                    content-cols-sm
                                    content-cols-lg="9"
                                    label="Profit în 2019"
                                >
                                    <b-form-input
                                        id="pf2019"
                                        v-model="form.pf2019"
                                        type="number"
                                        name="pf2019"
                                        :state="errors.length || form.pf2019 < 1 > 0? false : null"
                                    ></b-form-input>
                                    <small v-if="form.pf2019 < 1 || errors.length" class="text-danger">Firma nu are profit pe anul 2019</small>
                                </b-form-group>
                            </validation-provider>
                        </div>
                        <M3Warn
                            v-if="notEligible"
                            type="red"
                            :text="'<strong>ATENȚIE! Firma este în continuare neeligibilă.</strong>'"
                        ></M3Warn>
                        <div
                            :class="Number(form.ca2019) > Number(form.ca2020) &&
                                    Number(form.turnover_points) > 0 &&
                                    Number(form.pf2019) > 0 &&
                                    form.ca2019 > 49460 &&
                                    Number(form.date) < 2019 ? 'button-green-smaller' : 'button-red-smaller'"
                            @click="submitCompany()"
                        >Adaugă compania</div>
                    </b-form>
                </validation-observer>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {
        BModal,
        BForm,
        BFormGroup,
        BFormInput,
        BButton,
        BIconTrash,
        BFormTextarea,
        BFormFile,
        BIconUpload,
        BFormSelect,
        BFormDatepicker
    } from 'bootstrap-vue';
    import {ValidationProvider, ValidationObserver} from 'vee-validate'
    import M3Warn from '@/pages/Aplicatii/M3/M3Sketch/components/M3Warn'
    import axios from '@/helpers/axios'
    import api from '@/helpers/api'
    require('@/helpers/validations/validations')
    export default {
        components: {
            BModal,
            BForm,
            BFormGroup,
            BFormInput,
            BButton,
            BIconTrash,
            BFormTextarea,
            BFormFile,
            BIconUpload,
            BFormSelect,
            BFormDatepicker,
            M3Warn,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            neeligibilPopup: {
                type: Boolean,
                default: false
            },
            dateFirma: null,
            cfa2019: null,
            cfa2020: null,
        },
        data() {
            return {
                notEligible: false,
                caDifference: false,
                form: {
                    ca2019: '',
                    ca2020: '',
                    turnover_points: 0,
                    turnover_difference: 0,
                    pf2019: '',
                    date: '',
                },
                immTypes: [
                    { value: 'micro', text: 'ÎNTREPRINDERE MICRO' },
                    { value: 'mică', text: 'ÎNTREPRINDERE MICĂ' },
                    { value: 'mijlocie', text: 'ÎNTREPRINDERE MIJLOCIE' },
                ],
                vatStatuses: [
                    { value: 'NEPLATITOR', text: 'NEPLĂTITOR' },
                    { value: 'PLATITOR', text: 'PLĂTITOR' },
                ],
                showModal: null,
            };
        },
        watch: {
            dateFirma: function () {
                if(this.dateFirma){
                    this.getData()
                }

            },
            neeligibilPopup(newValue, oldValue){
                if(newValue !== oldValue){
                    this.neeligibilPopup = newValue;
                    this.showModal = this.neeligibilPopup;
                }
            }
        },
        mounted() {
            this.showModal = this.neeligibilPopup;
            this.getData()
        },
        methods: {
            onHide(evt) {
                if ( evt && evt.trigger === "backdrop") {
                    evt.preventDefault();
                    this.$emit('hideTempModal')
                }
            },
            getData() {
                this.form.ca2019 = this.dateFirma.ca2019
                this.form.ca2020 = this.dateFirma.ca2020
                this.form.pf2019 = this.dateFirma.pf2019
                this.form.date = 2021 - this.dateFirma.datainfiintare
                this.calculateCA()
            },
            calculateCA() {
                let vechi = Number(this.form.ca2019)
                let nou = Number(this.form.ca2020)
                if(!Number(this.form.ca2020)){
                    this.form.turnover_difference = 0
                } else{
                    let difference = (vechi - nou)*100/vechi
                    if(!nou) {
                        nou = 0;
                    }
                    this.form.turnover_difference = difference
                    if(!vechi || vechi < nou) {
                        this.caDifference = false
                        this.form.turnover_points = 0
                        return false
                    } else if (difference <= 5) {
                        this.caDifference = false
                        this.form.turnover_points = 0
                        return false
                    } else if(difference >= 5 && difference < 10) {
                        this.caDifference = true
                        this.form.turnover_points = 15
                        return 15
                    } else if(difference >= 10 && difference < 15) {
                        this.caDifference = true
                        this.form.turnover_points = 20
                        return 20
                    } else if(difference >= 15 && difference < 20) {
                        this.caDifference = true
                        this.form.turnover_points = 25
                        return 25
                    } else if(difference >= 20 && difference < 25) {
                        this.caDifference = true
                        this.form.turnover_points = 30
                        return 30
                    } else if(difference >= 25 && difference < 30) {
                        this.caDifference = true
                        this.form.turnover_points = 35
                        return 35
                    }else if(difference >= 30) {
                        this.caDifference = true
                        this.form.turnover_points = 40
                        return 40
                    }
                }
            },
            submitCompany() {
                this.$emit('submitCompany', this.form)
            },
            submitForm(event) {
                event.preventDefault();
                this.$refs.observer.validate().then((e) => {
                    if (!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {
                        axios.post(api.API_ENDPOINTS.m3statusPopupContact, this.form)
                            .then((response) => {
                                this.$toast.success(response.data.message);
                            })
                            .catch(xhr => {
                                if (xhr.response.status === 422) {
                                    this.errors.record(xhr.response.data.errors);
                                }
                                this.$toast.error(xhr.response.data.message);
                            })
                            .finally(() => {
                                this.$emit('hideTempModal')
                                this.onHide()
                            })
                    }
                })
            }
        },
    };
</script>

<style scoped>
.full-width {
    width: 100%;
}
.text-danger{
    position: absolute;
}
.modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.modal-body >>> .modal-header span {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}
.flex{
    display: flex;
}
.justify-between{
    justify-content: space-between;
}
.items-center{
    align-items: center;
}
.flex-start{
    align-items: flex-start;
}
.flex-column{
    flex-direction: column;
    display: flex;
}
.close-button {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 11px;
    line-height: 1;
    font-weight: 600;
    color: #000;
    background: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
a{
    font-size: 12px;
    text-align: right;
}
.modal-body p, .modal-body a {
    color: #fff;
}
form {
    max-width: 70%;
    margin-top: 30px !important;
}
.modal-body >>> .modal-header span {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}
.modal-header h2 {
    font-size: 31px;
    color: #fff;
    font-weight: 600;
}

.modal-header h3 {
    font-size: 16px;
    color: #fff;
    font-weight: 600;
    margin: 25px 0;
}
.red-text{
    color: var(--dangerColor);
}

.form-group >>> legend{
    font-size: 14px;
    min-width: 190px;
    max-width: 190px;
    opacity: 0.7;
    margin: 0;
    padding: 5px;
    color: #fff;
}
.form-group >>> .form-row{
    margin-bottom: 2.5px;
    flex-wrap: nowrap;
}
.form-group >>> input{
    font-size: 12px;
    width: 190px;
    color: #fff;
    background: transparent;
    border-color: #fff;
}
.imm-select >>> select{
    font-size: 12px;
    width: 190px;
    color: #fff;
    background: transparent;
    border-color: #fff;
    margin-bottom: 0;
}
.datepicker >>> .b-form-datepicker{
    background: transparent;
    font-size: 12px;
    color: #fff;
    border-color: #fff;
    max-width: 190px;
    margin-bottom: 0;
}
.b-form-datepicker >>> label, .b-form-datepicker >>> svg{
    color: #fff !important;
}
.b-form-datepicker >>> label{
    display: flex;
    align-items: center;
}
.imm-select >>> option{
    color: #000;
}
.form-control.is-invalid{
    border-color: #dc3545 !important;
}
.form-group >>> input::placeholder{
    font-size: 12px;
    color: #fff;
}
.form-group >>> textarea::placeholder{
    font-size: 12px;
    color: #fff;
}
.form-group >>> textarea{
    font-size: 12px;
    color: #fff;
    background: transparent;
    border-color: #fff;
}
.button-green-smaller{
    background: linear-gradient(to bottom, #36ad8c, #2b9477);
    color: #fff;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 9px 0;
    width: 100%;
    margin-top: 30px;
    max-width: 230px;
    min-height: 45px;
    border-radius: 4px;
    cursor: pointer;
    transition: 0.3s;
}
.button-red-smaller{
    background: linear-gradient(to bottom, #ff7070, #e05e5e);
    color: #fff;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.6;
    text-align: center;
    padding: 9px 0;
    width: 100%;
    margin-top: 30px;
    max-width: 230px;
    min-height: 45px;
    border-radius: 4px;
    cursor: default;
    transition: 0.3s;
    pointer-events: none;
}
@media(max-width: 1430px){
    .flex{
        flex-direction: column;
        max-width: 100%;
    }
    .justify-between{
        justify-content: flex-start;
    }
    .items-center{
        align-items: flex-start;
    }

}
@media screen and (max-width: 550px){
  .custom-modal-class {
    max-height: 80vh;
  }
  .custom-modal-class .custom-field-class >>> .form-row {
    flex-direction: column;
  }
  .custom-modal-class >>> .modal-header  {
    padding: 1rem 0;
  }
  .custom-modal-class >>> .modal-header h2 {
    font-size: 24px;
  }
  .custom-modal-class >>> .custom-inner-wrapper {
    max-width: 100%;
  }
  .custom-field-class >>> input {
    width: 100%;
  }
  .custom-modal-class .form-wrapper {
    width: 100%;
  }
  .custom-modal-class .button-red-smaller,
  .custom-modal-class .button-green-smaller{
    max-width: 100%;
  }
}
</style>
